<script>
import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
import templatable from "@/mixins/templatable";
import LotListAndFilters from "@/components/LotListAndFilters";
import {LOT_LIST_DEFAULT_LIMIT, LOT_LIST_DEFAULT_PAGE} from "@/constants";
import {updateLotsRoute} from "@/helpers";
import MyBidsShortList from "@/components/configuration/home/MyBidsShortList.vue";
import FavouriteLotsShortList from "@/components/configuration/home/FavouriteLotsShortList.vue";

export default {
  name: "DepartmentHome",
  components: {
    LotListAndFilters, MyBidsShortList, FavouriteLotsShortList
  },
  mixins: [templatable('departmentHomeTemplate')],
  props: {
    auctionUuid: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: true,
    loaded: false,
    selectedDepartment: null,
    template: `
        [[template]]
    `
  }),
  watch: {
    '$route.query': {
      // immediate: true,
      handler() {
        this.updateData()
      },
    },
    'lotQueryParams.department'() {
      this.findDepartment();
    },
    'departments.data'() {
      this.findDepartment();
    }
  },
  computed: {
    ...mapState(['lotListViewType', 'lotQueryParams', 'departments', 'categories']),
    ...mapGetters(['lotStatuses', 'lots']),
  },
  methods: {
    ...mapActions(['getLots', 'getDepartments']),
    ...mapMutations(['setLotFilters', 'emptyLotFilters', 'emptyLots']),
    ...mapMutations(['setError']),
    updateFilters(filters) {
      filters.page = LOT_LIST_DEFAULT_PAGE;
      this.setLotFilters(filters)
      updateLotsRoute()
    },
    updateData() {
      this.emptyLotFilters();
      this.setLotFilters({
        ...this.$route.query,
        department: this.$route.params.department,
      });
      if (this.$route.query.q) {
        this.getLots();
      }
      this.getDepartments();
    },
    findDepartment() {
      if (this.lotQueryParams.department && this.lotQueryParams.department && this.departments.data && this.departments.data.length > 0) {
        this.loading = false;
        this.loaded = true;
        const [key] = this.lotQueryParams.department || [];

        this.selectedDepartment = (this.departments?.data || []).find(d => d.key === key);
        if (!this.selectedDepartment) {
          this.setError({
            code: 404,
            message: this.$t('Department was not found.')
          })
        }
      }
    }
  },
  mounted() {
    this.updateData()
  },
  beforeDestroy() {
    this.emptyLots();
  },
  destroyed() {
    this.emptyLotFilters();
    this.setLotFilters({
      page: LOT_LIST_DEFAULT_PAGE,
      limit: LOT_LIST_DEFAULT_LIMIT
    });
  }
}
</script>

<style lang="scss" scoped>
#artisioTimedAuctions {
  .ta-departments-loading {
    width: 100%;
    text-align: center;
    padding: 3rem 0;
    font-size: 1.4rem;
  }

  .ta-department-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1rem;

    img {
      max-width: 128px;
      margin-bottom: 1rem;
    }
  }

  .ta-department-lot-search,
  .ta-department-title{
    margin-bottom: 1rem;
  }
}
</style>
